export class WbGravityFormsRenderer {
  constructor() {
    this.bindGlobalListeners();
  }

  init() {
    return new Promise((resolve) => {
      this.renderAllForms().then(resolve);
    });
  }

  bindGlobalListeners() {
    const _this = this;

    $(document).on('gform_post_render', function (event, form_id, current_page) {
      const form = document.querySelector(`#gform_${form_id}`);
      _this.addFileButtons(form);
    });
  }

  renderAllForms() {
    const _this = this;
    const gforms = document.querySelectorAll('.wb-gf-form');

    return new Promise((resolve) => {
      Promise.all([...gforms].map(_this.renderForm.bind(_this)))
        .then(_this.initDatePicker())
        .then(resolve);
    });
  }

  renderForm(gform) {
    const _this = this;

    return new Promise((resolve) => {
      _this.setData(gform).then(resolve);
    });
  }

  initDatePicker() {
    return new Promise((resolve, reject) => {
      if (window.gformInitDatepicker) gformInitDatepicker();
      resolve();
    });
  }

  setData(gform) {
    const _this = this;
    const DATA = new FormData();
    const id = gform.dataset.id;

    DATA.append('action', 'get_gf_form');
    DATA.append('form_id', id);

    return new Promise((resolve, reject) => {
      fetch(ajax_obj.ajaxurl, {
        method: 'POST',
        body: DATA,
      })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then((data) => {
          gform.innerHTML = data;
          gform.querySelector('form').setAttribute('action', window.location.pathname + '#gf_' + id);
          _this.resetScripts(gform).then(resolve);
        })
        .catch((error) => console.error(error));
    });
  }

  resetScripts(gform) {
    return new Promise((resolve, reject) => {
      const scripts = gform.querySelectorAll('script');

      scripts.forEach((e) => {
        const wrapper = gform.querySelector('.gform_wrapper');
        const scriptCode = e.innerHTML;
        const newScript = document.createElement('script');

        e.remove();

        Array.from(e.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));

        if (scriptCode) newScript.appendChild(document.createTextNode(scriptCode));

        document.querySelector('main')._insertAfter(newScript, wrapper);
      });

      resolve();
    });
  }

  addFileButtons(gform) {
    const buttons = gform?.querySelectorAll('[type="file"]');
    const buttonText = ajax_obj.lang === 'fr' ? 'Choisir un fichier' : 'Choose a file';

    buttons?.forEach((button) => {
      const field = button.closest('.gfield');

      const icon = document.createElement('i');
      icon.classList.add('far', 'fa-paperclip');

      const fakeBtn = document.createElement('button');
      fakeBtn.type = 'button';
      fakeBtn.textContent = buttonText;
      fakeBtn.classList.add('button', 'button--alternative', 'button--icon', 'button--icon--left', 'gform-file-button');
      fakeBtn.setAttribute('aria-controls', button.getAttribute('id'));
      fakeBtn.prepend(icon);

      document.querySelector('body')._insertAfter(fakeBtn, button);

      fakeBtn.addEventListener('click', () => button.click());

      button.addEventListener('change', (e) => {
        let file = field.querySelector('.gform-file-button__file');

        if (!file) {
          file = document.createElement('span');
          file.classList.add('gform-file-button__file');
        }

        file.textContent = e.currentTarget.files[0].name;
        document.querySelector('body')._insertAfter(file, fakeBtn);
      });
    });

    document.querySelectorAll('.gform_button_select_files')?.forEach((button) => {
      const icon = document.createElement('i');
      icon.classList.add('far', 'fa-paperclip');

      button.insertBefore(icon, button.firstChild);
      button.classList.add('button', 'button--alternative', 'button--icon', 'button--icon--left', 'gform-file-button');
    });
  }
}
